import { useMutation, useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { SimpleModal, Box } from '@sequencehq/core-components'
import {
  GreyGrey80,
  Primary13SemiBold,
  Primary13Regular
} from '@sequencehq/core-components'
import { useNotifications } from '@sequencehq/core-components'

export const ArchiveCustomerModal = (props: {
  trigger: React.ReactElement
  customerId: string
  onClose?: () => void
}) => {
  const customerQuery = useQuery(dashboard20240730Client.getCustomer, {
    id: props.customerId
  })
  const { displayNotification } = useNotifications()
  const archiveCustomerMutation = useMutation(
    dashboard20240730Client.postArchiveCustomer,
    {
      onSuccess: () => {
        displayNotification(
          `${customerQuery.data?.legalName ?? 'customer'} archived`,
          {
            type: 'success'
          }
        )
      },
      onError: () => {
        displayNotification(
          `Unable to archive ${customerQuery.data?.legalName ?? 'customer'}`,
          {
            type: 'error'
          }
        )
      }
    }
  )

  return (
    <SimpleModal
      trigger={props.trigger}
      variant="dialog"
      title={`Archive ${customerQuery.data?.legalName ?? 'customer'}`}
      isLoading={customerQuery.isPending}
      onClose={() => props.onClose?.()}
      submitButtonText="Archive"
      submittingButtonText="Archiving..."
      onSubmit={async () => {
        const res = await archiveCustomerMutation.mutateAsync({
          id: props.customerId
        })
        return Boolean(res)
      }}
      isDestructive
      data-testid="archiveCustomer.modal"
    >
      <Box color={GreyGrey80} {...Primary13Regular} marginBottom="8px">
        This will archive the customer immediately. All billing schedules for
        this customer will be archived and any remaining draft invoices will be
        voided. Finalised and sent invoices will remain.
      </Box>
      <Box color={GreyGrey80} {...Primary13SemiBold}>
        This action cannot be undone.
      </Box>
    </SimpleModal>
  )
}
